module.exports = __webpack_public_path__ + "media/1100_SERF_2022_InsiderThreats.1546a483.mp4";